import ApiService from 'api-client/ApiService'
import config from 'app-config'
import { getIDPName } from './helpers'
import { GetSsoAttributesResponse } from 'app/plugins/account/components/ssoManagement/attributes/model'
import ApiError from 'core/errors/ApiError'

class Hagrid extends ApiService {
  public getClassName() {
    return 'hagrid'
  }

  protected async getEndpoint() {
    let apiEndpoint = config.apiHost
    const serviceEndpoint = await this.client.keystone.getServicesEndpointForTypeAndRegion(
      'keystone',
      'public',
      'Infra',
    )
    if (serviceEndpoint) {
      apiEndpoint = new URL(serviceEndpoint).origin
    }
    return Promise.resolve(apiEndpoint)
  }

  get baseUrl(): string {
    return `/hagrid`
  }

  getSsoDetails = async () => {
    return this.client.rawGet({
      url: `${this.baseUrl}/sso`,
      options: {
        clsName: this.getClassName(),
        mthdName: 'getSsoDetails',
      },
    })
  }

  getSsoConfig = async () => {
    return this.client.basicGet({
      url: `${this.baseUrl}/ssoconfig/${getIDPName()}`,
      options: {
        clsName: this.getClassName(),
        mthdName: 'getSsoConfig',
      },
    })
  }

  createSsoConfig = async (body) => {
    try {
      return this.client.basicPost({
        url: `${this.baseUrl}/ssoconfig`,
        body,
        options: {
          clsName: this.getClassName(),
          mthdName: 'createSsoConfig',
        },
      })
    } catch (err) {
      throw new ApiError(err || 'Failed to create SSO config')
    }
  }

  deleteSsoConfig = async () => {
    try {
      await this.client.basicDelete({
        url: `${this.baseUrl}/ssoconfig/${getIDPName()}`,
        options: {
          clsName: this.getClassName(),
          mthdName: 'deleteSsoConfig',
        },
      })
    } catch (err) {
      throw new ApiError(err || 'Failed to delete SSO config')
    }
  }

  getSsoAttributes = async () => {
    return this.client.basicGet<GetSsoAttributesResponse>({
      url: `${this.baseUrl}/ssoconfig/${getIDPName()}/attributes`,
      options: {
        clsName: this.getClassName(),
        mthdName: 'getSsoAttributes',
      },
    })
  }
}

export default Hagrid
